<template>
    <div style="margin-top: 10px">
        <el-form inline ref="form" :model="queryForm" style="text-align: center">
            <el-form-item>
                <el-input clearable v-model="queryForm.userName" placeholder="Username"></el-input>
            </el-form-item>

            <el-form-item>
                <el-input clearable v-model="queryForm.phone" placeholder="Phone"></el-input>
            </el-form-item>

            <el-form-item>
                <el-input clearable v-model="queryForm.email" placeholder="Email"></el-input>
            </el-form-item>

            <el-form-item>
                <el-input clearable v-model="queryForm.eazableCode" placeholder="QR Code"></el-input>
            </el-form-item>

            <el-button type="primary" icon="el-icon-search" circle @click="loadData"></el-button>
        </el-form>

        <el-table
                v-loading="loading"
                fit
                stripe
                highlight-current-row
                @expand-change="tableExpand"
                class="data-table"
                @row-click="openEdit"
                :data="data">
            <el-table-column type="expand" label="Eazable" width="100px">
                <template slot-scope="s">
                    <el-table
                            v-loading="propertyLoading"
                            :data="s.row.property"
                            style="width: 100%">
                        <el-table-column
                                label="Property Name"
                                prop="propertyName">
                        </el-table-column>

                        <el-table-column
                                label="Blk No"
                                prop="blkNo">
                        </el-table-column>

                        <el-table-column
                                label="Unit No"
                                prop="unitNo">
                        </el-table-column>

                        <el-table-column
                                label="Eazable"
                                prop="eazableCode">
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'userName',label:'User Name',wth:'160px'},
                        {prop:'phone',label:'Phone',wth:'120px'},
                        {prop:'email',label:'Email'},
                        {prop:'bid',label:'Code'},
                        {prop:'role',label:'Role',fmt:roleFmt},
                        {prop:'status',label:'Status',fmt:statusFmt},
                        {prop:'balance',label:'E-wallet Balance',wth:'150px'},
                        {prop:'updateTime',label:'Updated Time',fmt:selfTimeFormat}
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :width="item.wth"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column
                    label="Action" width="80px">
                <template slot-scope="s">
                    <el-tooltip :content="s.row.status===2?'Activate':'Deactivate'" placement="top">
                        <el-button type="text" circle @click="changeStatus(s.row)"
                                   :style="s.row.status===2?'background-color: #19be6b;color: white':'background-color: #FF3030;color: white'"
                                   :icon="s.row.status===2?'el-icon-turn-off':'el-icon-open'"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {usersList, changeStatus, userProperty} from '@/api/UsersAPI'

    export default {
        name: "Users",
        data: function () {
            return {
                dialogVisible: false,
                isCreate: false,
                queryForm: {},
                propertyLoading: false,
                form: {},
                loading: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                rules: {
                    year: [
                        {required: true, message: 'Year is required', trigger: 'blur'},
                    ],
                    dayList: [
                        {required: true, message: 'Please input the holidays ', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            tableExpand(row) {
                if (!row.property) {
                    this.propertyLoading = true
                    userProperty(row.id)
                        .then(res => {
                            row.property = res.data
                            this.propertyLoading = false
                        })
                }
            },
            loadData() {
                this.$pageUtils(this, usersList)
            },
            changeStatus(data) {
                changeStatus(data.id)
                    .then(this.loadData);
            },
            openCreate() {
                this.form = {}
                this.dialogVisible = true
            },
            statusFmt(row, col, cell) {
                return cell === 1 ? 'Active' : 'InActive'
            },
            openEdit(row) {
                this.form = this.$copy(row);
                this.dialogVisible = true
            },
            roleFmt(row, col, cell) {
                return cell === 0 ? 'Public' : 'Linked'
            },
            saveData() {
                // const action = this.form.id ? holidayUpdate : holidayCreate;
                // this.$refs['form'].validate((valid) => {
                //     if (valid) {
                //         action(this.form)
                //             .then(() => {
                //                 this.loadData()
                //                 this.dialogVisible = false
                //             })
                //     }
                // })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
